import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import typewriter from 'madow-tech/modifiers/typewriter';
import activeStateWatcher from 'madow-tech/modifiers/active-state-watcher';

export default class TypewriterSequence extends Component {
  @tracked loadingComplete = false;
  @tracked showReady = false;
  @tracked nameActive = false;
  @tracked nameComplete = false;
  @tracked roleActive = false;
  @tracked animationCompleted = false;

  get nameText() {
    return this.args.name || '';
  }

  get roleText() {
    return this.args.role || '';
  }

  get speed() {
    return this.args.speed || 50;
  }

  get loadingDelay() {
    return this.args.loadingDelay || 100;
  }

  get nameDelay() {
    return this.args.nameDelay || 300;
  }

  get roleDelay() {
    return this.args.roleDelay || 200;
  }

  @action
  resetState() {
    // Solo resetear si no estamos activos
    if (!this.args.active) {
      this.loadingComplete = false;
      this.showReady = false;
      this.nameActive = false;
      this.nameComplete = false;
      this.roleActive = false;
      this.animationCompleted = false;
    }
  }

  @action
  onLoadingComplete() {
    this.loadingComplete = true;
    // Activar el nombre directamente después del loading
    setTimeout(() => {
      this.nameActive = true;
    }, this.nameDelay);
  }

  @action
  onNameComplete() {
    this.nameComplete = true;
    // Activar el role después de un pequeño delay
    setTimeout(() => {
      this.roleActive = true;
    }, this.roleDelay);
  }

  @action
  onRoleComplete() {
    // Mostrar "Ready" cuando termina el rol
    setTimeout(() => {
      this.showReady = true;
      // Marcar como completado después de mostrar Ready
      setTimeout(() => {
        this.animationCompleted = true;
        if (this.args.onComplete) {
          this.args.onComplete();
        }
      }, 800);
    }, 300);
  }

  <template>
    <div
      class="typewriter-sequence"
      {{activeStateWatcher @active onReset=this.resetState}}
      ...attributes
    >
      {{! Loading/Ready indicator }}
      {{#if this.animationCompleted}}
        {{! Mostrar todo completo cuando la animación terminó }}
        <div class="text-xs text-green-400 font-mono">✓ Ready</div>
        <h3 class="mt-4 text-[11px] min-[550px]:text-base font-semibold">{{this.nameText}}</h3>
        <p class="text-xs text-zinc-200">{{this.roleText}}</p>
      {{else}}
        {{! Secuencia de animación }}
        {{#if this.showReady}}
          <div class="text-xs text-green-400 font-mono">✓ Ready</div>
        {{else if @active}}
          <div
            class="text-xs text-green-400 font-mono loading-text"
            {{typewriter
              "> Loading profile..."
              active=@active
              speed=40
              delay=this.loadingDelay
              onComplete=this.onLoadingComplete
              cursor=true
            }}
          ></div>
        {{else if this.loadingComplete}}
          {{! Mantener espacio vacío donde estaba loading para mostrar Ready después }}
          <div
            class="text-xs text-green-400 font-mono opacity-0"
          >placeholder</div>
        {{/if}}

        {{! Nombre }}
        {{#if this.nameActive}}
          <h3
            class="mt-4 text-[11px] min-[550px]:text-base font-semibold typewriter-name"
            {{typewriter
              this.nameText
              active=this.nameActive
              speed=this.speed
              delay=0
              onComplete=this.onNameComplete
              cursor=true
            }}
          ></h3>
        {{/if}}

        {{! Role }}
        {{#if this.roleActive}}
          <p
            class="text-xs !text-zinc-200 typewriter-role"
            {{typewriter
              this.roleText
              active=this.roleActive
              speed=this.speed
              delay=0
              onComplete=this.onRoleComplete
              cursor=true
              isLast=true
            }}
          ></p>
        {{/if}}
      {{/if}}
    </div>
  </template>
}
